import React from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ls from 'local-storage'

const styles = theme => ({
    root: {
        flexGrow: 1,
        overflow: 'hidden',
    },
    paper: {
        padding: theme.spacing.unit,
        margin: theme.spacing.unit,
    },
    card: {
      minWidth: 275,
    },
    bullet: {
      display: 'inline-block',
      margin: '0 2px',
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 18,
      fontWeight: 'bold',
    },
    pos: {
      marginBottom: 12,
    },
    group: {
      margin: `${theme.spacing.unit}px 0`,
    },
    formControl: {
        margin: theme.spacing.unit,
    },
    formLabel: {
        textAlign: 'left',
    },
    formInput: {
        padding: 0,
    },
    greenradio: {
        color: green[600],
        '&$checked': {
            color: green[500],
        },
    },
    redradio: {
        color: red[600],
        '&$checked': {
            color: red[500],
        },
    },
    checked: {},
    divider: {
        margin: 16,
    },
    button: {
        marginRight: theme.spacing.unit,
    },
});

class ClaimENValidate extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.props = props;
    }

    state = {
        fp17data: this.props.fp17data,
        dentist_id: '',
        clinicians: [],
        valid: false,
    };

    checkClaimValid() {
        // need to check we've got everything we need for a valid claim

    }
    
    componentDidMount() {
        this._isMounted = true;

        // no claim data - claim validate from admin section
        // load the claim data
        if (!this.props.fp17data) {
            if (this.props.form_id)
            {
                this.props.socket.emit("claim_data", {formid:this.props.form_id,authenticator:ls.get("authenticator")});        
                this.setState({form_id: this.props.form_id});
            }

            this.props.socket.on("claim_data_result",(d)=>{
                if (this._isMounted) {
                    //console.log(d);

                    this.setState({fp17data: d[0].form_data});
                }            
            });               
        }

        this.props.socket.emit("claim_clinicians",{authenticator:ls.get("authenticator")});
        this.checkClaimValid();

        this.props.socket.on("claim_clinicians_result",(d)=>{
            if (this._isMounted) {
                this.setState({clinicians:d});

                //console.log(this.state);
            }
        }); 

        this.props.socket.on("claim_validate_result",(d)=>{
            //console.log(d);
            if (this._isMounted) {
                this.closeValidate();
            }
        });

             
    } 

    componentWillUnmount() {
        this._isMounted = false;
    } 

    handleTextChange = name => async event => {
        //console.log(name, event.target.value);

        await this.setState({[name]: event.target.value}); 

        if (this.state.dentist_id)
            this.setState({valid: true});
        else
            this.setState({valid: false});

        //console.log(this.state);
    };    

    handleCheckChange = name => event => {
        //this.setState({ [name]: event.target.value });
        let value = undefined;

        if (event.target.checked === true)
            value = event.target.value;
        else
            value = undefined;

        let datatmp = this.state.fp17data;
        datatmp[name] = value;
        this.setState({fp17data: datatmp}); 
    };

    validateForm = () => {
        //console.log(this.props);

        if (this.props.form_id) {
            // we're validating a saved form, resave the form, save the declaration and then submit to batch
            if (this.props.source === "claim_list") {
                // don't save the form, just the validation
                this.props.socket.emit("claim_validate", {form_id: this.props.form_id, claimdata: this.state, source: this.props.source,authenticator:ls.get("authenticator")});

            } else {
                //this.props.formSaveFunction();

            }
            //console.log('validate existing');

        } else {
            // we need to save the form, and submit it to the batch
            //console.log('save & validate');
        }         

        /*if (this._isMounted) {
            this.props.socket.emit("claim_validate", {form_id: this.state.form_id, fp17data: this.state.claimdata,authenticator:ls.get("authenticator")});
        }*/
    }     

    closeValidate = () => {
        this.props.closeFunction();
    }

    renderDentistOptions() {
        if (this.state.clinicians)
        {
            return this.state.clinicians.map((dt, i) => {
                return (
                    <MenuItem
                    key={dt.staff_id}
                    value={dt.staff_id}>
                    {dt.displayname}
                    </MenuItem>
                );
            });
        }
        else
        {
            return;
        }
    }     

    render() {
        const { classes } = this.props;

        return (
        <div className={classes.root}>
            <DialogTitle id="alert-dialog-title">{"Validate Claim"}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <FormControl className={classes.formControl} fullWidth={true}>
                                <InputLabel htmlFor="validate-dentist">Dentist</InputLabel>
                                <Select
                                value={this.state.dentist_id}
                                onChange={this.handleTextChange('dentist_id')}
                                inputProps={{
                                    name: 'dentist_id',
                                    id: 'validate-dentist',
                                }}
                                >
                                    <MenuItem/>
                                    {this.renderDentistOptions()}
                                </Select>
                            </FormControl>                        
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl className={classes.formControl} fullWidth={true}>
                                <FormControlLabel
                                    value="1"
                                    control={<Checkbox />}
                                    onChange={this.handleCheckChange('dec1')}
                                    label="All the necessary care and treatment that the patient is willing to undergo will be provided"
                                />
                            </FormControl>                
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl className={classes.formControl} fullWidth={true}>
                                <FormControlLabel
                                    value="1"
                                    control={<Checkbox />}
                                    onChange={this.handleCheckChange('dec2')}
                                    label="All the currently necessary care and treatment that the patient is willing to undergo has been carried out"
                                />
                            </FormControl>                
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl className={classes.formControl} fullWidth={true}>
                                <FormControlLabel
                                    value="1"
                                    control={<Checkbox />}
                                    onChange={this.handleCheckChange('dec3')}
                                    label="I declare that I am properly entitled to practise under the current dental regulations and that the
                                        information I have given on this form is correct and complete. I understand that if it is not,
                                        appropriate action may be taken. For the purpose of verification of this and the prevention and
                                        detection of fraud and incorrectness, I consent to the disclosure of relevant information from
                                        this form to and by the NHS Business Services Authority. "
                                />
                            </FormControl>                
                        </Grid>                                       
                    </Grid>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" color="secondary" className={classes.button} 
                    onClick={this.closeValidate}>Cancel</Button>
                <Button variant="contained" color="primary" 
                    className={classes.button} onClick={this.validateForm} autoFocus 
                    disabled={!this.state.valid}>Validate Claim</Button>
            </DialogActions>
        </div>
        );
    }
}

ClaimENValidate.propTypes = {
    classes: PropTypes.object.isRequired,
  };
  
  export default withStyles(styles)(ClaimENValidate);